// Appends a per-field note ("Dodatkowa uwaga") to a summary-table answer,
// mirroring the backend CSV export (CsvNoteFormatter): "answer, [note]", or
// "[note]" alone when the answer is empty. Returns the answer unchanged when
// there is no note. Kept as a small pure helper shared by the two summary
// table views (FilledFormData and UserFilledFormData).
export const appendNote = (value, note) => {
  const base = value == null ? "" : String(value);
  if (!note) {
    return base;
  }
  return base ? `${base}, [${note}]` : `[${note}]`;
};
